import * as actions from 'actions'

import { fetchIfLoggedIn } from '../utils.js'

export const getUserApps = () => dispatch => {
  return dispatch(
    fetchIfLoggedIn({
      actionType: actions.GET_USER_APPS,
      method: 'get',
      path: `/access/apps?type=UI`,
    })
  )
}

export const getUserAppsV1 = () => dispatch => {
  return dispatch(
    fetchIfLoggedIn({
      actionType: actions.GET_USER_APPS_V1,
      method: 'get',
      path: `/access/apps?type=UI`,
    })
  )
}

export const getUserEnvironments = () => dispatch => {
  return dispatch(
    fetchIfLoggedIn({
      actionType: actions.GET_USER_ENVIRONMENTS,
      method: 'get',
      path: `/access/environments?type=UI`,
    })
  )
}

export const getUserEnvironmentsV1 = () => dispatch => {
  return dispatch(
    fetchIfLoggedIn({
      actionType: actions.GET_USER_ENVIRONMENTS_V1,
      method: 'get',
      path: `/access/environments?type=UI`,
    })
  )
}

export const getUserProfiles = () => dispatch => {
  return dispatch(
    fetchIfLoggedIn({
      actionType: actions.GET_USER_PROFILES,
      method: 'get',
      path: `/access/profiles?type=UI`,
    })
  )
}

export const getUserProfilesV1 = () => dispatch => {
  return dispatch(
    fetchIfLoggedIn({
      actionType: actions.GET_USER_PROFILES_V1,
      method: 'get',
      path: `/access/profiles?type=UI`,
    })
  )
}

export const getAllProfiles = () => dispatch => {
  return dispatch(
    fetchIfLoggedIn({
      actionType: actions.GET_ALL_PROFILES,
      method: 'get',
      path: `/access?type=UI`,
    })
  )
}

export const getAllProfilesV1 = () => dispatch => {
  return dispatch(
    fetchIfLoggedIn({
      actionType: actions.GET_ALL_PROFILES_V1,
      method: 'get',
      path: `/access?type=UI`,
    })
  )
}

export const getFrequentlyUsedProfiles = postCheckout => dispatch => {
  return dispatch(
    fetchIfLoggedIn({
      actionType: actions.GET_FREQUENTLY_USED_PROFILES,
      meta: { postCheckout },
      method: 'get',
      path: `/access/frequently-used`,
    })
  )
}

export const getFrequentlyUsedProfilesV1 = postCheckout => dispatch => {
  return dispatch(
    fetchIfLoggedIn({
      actionType: actions.GET_FREQUENTLY_USED_PROFILES_V1,
      meta: { postCheckout },
      method: 'get',
      path: `/access/frequently-used`,
    })
  )
}

export const getFavoriteProfiles = () => dispatch => {
  return dispatch(
    fetchIfLoggedIn({
      actionType: actions.GET_FAVORITE_PROFILES,
      method: 'get',
      path: `/access/favorites?accessTypeRequired=false`,
    })
  )
}

export const getFavoriteProfilesV1 = () => dispatch => {
  return dispatch(
    fetchIfLoggedIn({
      actionType: actions.GET_FAVORITE_PROFILES_V1,
      method: 'get',
      path: `/access/favorites`,
    })
  )
}

export const markPapFavorite = (
  appContainerId,
  environmentId,
  papId,
  accessType
) => dispatch => {
  return dispatch(
    fetchIfLoggedIn({
      actionType: actions.MARK_FAVORITE,
      meta: {
        appContainerId,
        environmentId,
        papId,
        accessType,
      },
      postBody: {
        appContainerId,
        environmentId,
        papId,
        accessType,
      },
      method: 'post',
      path: '/access/favorites',
    })
  )
}

export const markPapFavoriteV1 = (
  appContainerId,
  environmentId,
  papId,
  accessType
) => dispatch => {
  return dispatch(
    fetchIfLoggedIn({
      actionType: actions.MARK_FAVORITE_V1,
      meta: {
        appContainerId,
        environmentId,
        papId,
        accessType,
      },
      postBody: {
        appContainerId,
        environmentId,
        papId,
        accessType,
      },
      method: 'post',
      path: '/access/favorites',
    })
  )
}

export const deletePapFavorite = (
  favoriteId,
  appContainerId,
  environmentId,
  papId,
  accessType
) => dispatch => {
  return dispatch(
    fetchIfLoggedIn({
      actionType: actions.DELETE_FAVORITE,
      meta: {
        favoriteId,
        appContainerId,
        environmentId,
        accessType,
        papId,
      },
      method: 'delete',
      path: `/access/favorites/${favoriteId}`,
    })
  )
}

export const deletePapFavoriteV1 = (
  favoriteId,
  appContainerId,
  environmentId,
  papId,
  accessType
) => dispatch => {
  return dispatch(
    fetchIfLoggedIn({
      actionType: actions.DELETE_FAVORITE_V1,
      meta: {
        favoriteId,
        appContainerId,
        environmentId,
        accessType,
        papId,
      },
      method: 'delete',
      path: `/access/favorites/${favoriteId}`,
    })
  )
}

export const papCheckIn = (
  transactionId,
  accessStatusId,
  papId,
  environmentId,
  appContainerId,
  accessType,
  type
) => dispatch => {
  return dispatch(
    fetchIfLoggedIn({
      actionType: actions.ACCESS_CHECK_IN_PAP,
      meta: {
        environmentId,
        papId,
        appContainerId,
        accessType,
        transactionId,
        type,
      },
      method: 'put',
      path: `/access/${transactionId}?type=API`,
    })
  )
}

export const submitCheckIn = (
  transactionId,
  papId,
  environmentId,
  appContainerId,
  accessType,
  type
) => dispatch => {
  return dispatch(
    fetchIfLoggedIn({
      actionType: actions.ACCESS_CHECK_IN_SUBMIT,
      meta: {
        environmentId,
        papId,
        appContainerId,
        accessType,
        transactionId,
        type,
      },
      method: 'put',
      path: `/access/${transactionId}?type=API`,
    })
  )
}

export const papCheckOut = (
  papId,
  environmentId,
  appContainerId,
  accessType,
  papName
) => dispatch => {
  return dispatch(
    fetchIfLoggedIn({
      actionType: actions.ACCESS_CHECK_OUT_PAP,
      method: 'post',
      meta: { environmentId, papId, appContainerId, accessType, papName },
      path: `/access/${papId}/environments/${environmentId}?accessType=${accessType}`,
    })
  )
}

export const submitCheckOut = (
  papId,
  environmentId,
  appContainerId,
  accessType,
  papName,
  postBody = {}
) => dispatch => {
  return dispatch(
    fetchIfLoggedIn({
      actionType: actions.ACCESS_CHECK_OUT_SUBMIT,
      method: 'post',
      meta: { environmentId, papId, appContainerId, accessType, papName },
      path: `/access/${papId}/environments/${environmentId}?accessType=${accessType}`,
      postBody,
    })
  )
}

export const submitApprovalRequired = (
  papId,
  environmentId,
  appContainerId,
  accessType,
  papName,
  postBody = {}
) => dispatch => {
  return dispatch(
    fetchIfLoggedIn({
      actionType: actions.APPROVAL_REQUEST_SUBMIT,
      method: 'post',
      meta: { environmentId, papId, appContainerId, accessType, papName },
      path: `/access/${papId}/environments/${environmentId}/approvalRequest`,
      postBody,
    })
  )
}

export const submitWithdrawRequest = (
  resourceId,
  papId,
  environmentId,
  appContainerId,
  accessType,
  papName,
  consumer = 'papservice'
) => dispatch => {
  return dispatch(
    fetchIfLoggedIn({
      actionType: actions.REQUEST_CANCELLED_NOTIFICATION, // actionType added here
      meta: { environmentId, papId, appContainerId, accessType, papName },
      method: 'delete',
      path: `/v1/approvals/consumer/${consumer}/resource?resourceId=${resourceId}`,
    })
  )
}

export const getCheckedOutProfiles = isBackgroundPoller => dispatch => {
  return dispatch(
    fetchIfLoggedIn({
      actionType: actions.GET_CHECKED_OUT_PROFILES,
      method: 'get',
      meta: { isBackgroundPoller },
      path: '/access/app-access-status?showInProgress=true',
    })
  )
}

export const getAppAccessStatus = () => dispatch => {
  return dispatch(
    fetchIfLoggedIn({
      actionType: actions.GET_APP_ACCESS_STATUS,
      method: 'get',
      path: '/access/app-access-status?showInProgress=true',
    })
  )
}

export const fetchSharedPapStatusV1 = () => dispatch => {
  return dispatch(
    fetchIfLoggedIn({
      actionType: actions.FETCH_SHARED_PAP_STATUS_V1,
      method: 'get',
      path: `/access/app-shared-account-info`,
    })
  )
}

export const fetchSharedPapStatus = () => dispatch => {
  return dispatch(
    fetchIfLoggedIn({
      actionType: actions.FETCH_SHARED_PAP_STATUS,
      method: 'get',
      path: `/access/app-shared-account-info`,
    })
  )
}

export const extendExpiration = transactionId => dispatch => {
  return dispatch(
    fetchIfLoggedIn({
      actionType: actions.EXTEND_EXPIRATION,
      method: 'patch',
      path: `/access/extensions/${transactionId}`,
    })
  )
}

export const fetchApprovers = (
  profileId,
  consumer = 'papservice',
  action = 'papservice.profile.access',
  resourceId,
  myResources = false // Default to false if not provided
) => dispatch => {
  // Determine the method and path based on the myResources flag
  const method = myResources ? 'get' : 'post'
  const path = myResources
    ? `/resource-manager/my-resources/profiles/${profileId}/resources/${resourceId}/getApprovers`
    : '/v1/policy-admin/policies/approvers'

  // Build the post body if it's a POST request
  const postBody = {
    consumer,
    resource: `${profileId}/*`,
    action,
  }

  return dispatch(
    fetchIfLoggedIn({
      actionType: actions.FETCH_APPROVERS,
      method,
      path,
      ...(method === 'post' && { postBody }), // Only send postBody if the method is POST
    })
  )
}

export const submitRequest = (
  papId,
  environmentId,
  appContainerId,
  accessType,
  papName,
  postBody = {}
) => dispatch => {
  return dispatch(
    fetchIfLoggedIn({
      actionType: actions.ACCESS_REQUEST_SUBMIT,
      method: 'post',
      meta: { environmentId, papId, appContainerId, accessType, papName },
      path: `/access/${papId}/environments/${environmentId}/approvalRequest`,
      postBody,
    })
  )
}

export const withdrawRequest = (
  appContainerId,
  environmentId,
  papId,
  papName
) => dispatch => {
  return dispatch(
    fetchIfLoggedIn({
      actionType: actions.REQUEST_CANCELLED_NOTIFICATION,
      meta: {
        appContainerId,
        environmentId,
        papId,
        papName,
      },
      method: 'delete',
      path: `/v1/approvals/consumer/papservice/resource?resourceId=${papId}/${environmentId}`,
    })
  )
}

export const cancelExtension = payload => {
  return {
    type: actions.CANCEL_EXTENSION,
    payload,
  }
}

export const showApprovalModal = payload => {
  return {
    type: actions.SHOW_APPROVAL_MODAL,
    payload,
  }
}

export const hideApprovalModal = payload => {
  return {
    type: actions.HIDE_PPROVAL_MODAL,
    payload,
  }
}

export const addToExtensionQueue = payload => {
  return {
    type: actions.ADD_TO_EXTENSION_QUEUE,
    payload,
  }
}

export const addInternalTimer = payload => {
  return {
    type: actions.ADD_INTERNAL_TIMER,
    payload,
  }
}

export const getAssociations = profileId => dispatch => {
  return dispatch(
    fetchIfLoggedIn({
      actionType: actions.GET_MY_ACCESS_ASSOCIATIONS,
      method: 'get',
      meta: profileId,
      path: `/access/pap-scopes/${profileId}`,
    })
  )
}

export const getSessionAssociations = profileId => dispatch => {
  return dispatch(
    fetchIfLoggedIn({
      actionType: actions.GET_MY_ACCESS_ASSOCIATIONS,
      method: 'get',
      meta: profileId,
      path: `/paps/sessions/pap-scopes/${profileId}`,
    })
  )
}

export const saveMyAccessFilter = (userId, data) => dispatch => {
  return dispatch(
    fetchIfLoggedIn({
      actionType: actions.SAVE_MY_ACCESS_COLLECTIONS,
      method: 'post',
      path: `/access/${userId}/filters`,
      postBody: data,
    })
  )
}

export const getSavedMyAccessFilter = userId => dispatch => {
  return dispatch(
    fetchIfLoggedIn({
      actionType: actions.GET_SAVED_MY_ACCESS_COLLECTIONS,
      method: 'get',
      path: `/access/${userId}/filters`,
    })
  )
}

export const deleteMyAccessFilter = (userId, filterId) => dispatch => {
  return dispatch(
    fetchIfLoggedIn({
      actionType: actions.DELETE_MY_ACCESS_COLLECTIONS,
      method: 'delete',
      path: `/access/${userId}/filters/${filterId}`,
      meta: { filterId },
    })
  )
}

export const updateMyAccessFilter = (userId, filterId, data) => dispatch => {
  return dispatch(
    fetchIfLoggedIn({
      actionType: actions.UPDATE_MY_ACCESS_COLLECTIONS,
      method: 'put',
      path: `/access/${userId}/filters/${filterId}`,
      postBody: data,
      meta: { filterId, data },
    })
  )
}

export const moveSelectedCollectionFilterIndex = currentCollectionIndex => {
  return {
    type: actions.MOVE_SELECTED_COLLECTION_FILTER_INDEX,
    payload: { currentCollectionIndex },
  }
}

export const fetchAdvancedSettingsForAccessProfile = (papId, envId) => dispatch => {
  return dispatch(
    fetchIfLoggedIn({
      actionType: actions.FETCH_ADVANCED_SETTINGS_FOR_ACCESS_PROFILE,
      method: 'get',
      path: `/access/${papId}/environments/${envId}/settings`,
    })
  )
}

export const removeAdvancedSettingsForAccessProfile = () => {
  return {
    type: actions.REMOVE_ADVANCED_SETTINGS_FOR_ACCESS_PROFILE,
  }
}

export const searchTicketsForAccessProfile = (
  papId,
  envId,
  ticketType,
  searchText
) => dispatch => {
  return dispatch(
    fetchIfLoggedIn({
      actionType: actions.SEARCH_TICKETS_FOR_ACCESS_PROFILE,
      method: 'get',
      path: `/access/${papId}/environments/${envId}/itsm/${ticketType}/search`,
      params: { searchText },
    })
  )
}

export const removeTicketSearchResultsForAccessProfile = () => {
  return {
    type: actions.REMOVE_SEARCH_RESULTS_FOR_ACCESS_PROFILE,
  }
}

export const getTicketDetails = (connId, type, ticketId) => dispatch => {
  return dispatch(
    fetchIfLoggedIn({
      actionType: actions.GET_TICKET_DETAILS,
      method: 'get',
      path: `/itsm-integration/connections/${connId}/ticketTypes/${type}/tickets/${ticketId}`,
    })
  )
}

export const findTicketDetailsById = (
  papId,
  envId,
  ticketType,
  ticketId
) => dispatch => {
  return dispatch(
    fetchIfLoggedIn({
      actionType: actions.FIND_TICKET_DETAILS_BY_ID,
      method: 'get',
      path: `/access/${papId}/environments/${envId}/itsm/${ticketType}/validate/${ticketId}`,
    })
  )
}
